import React, { useEffect, useRef, useState } from "react";

import { useIntl } from "react-intl";

import SearchIcon from "@atlaskit/icon/glyph/search";

import { Cross } from "../../../../libraries/wpl/foundations/src/";
import { TextInput } from "../../../wpl/text-input/src";

import {
    closePanelIconContainerStyle,
    searchFormStyle,
    searchContainerStyle,
    searchInputContainerStyle,
    searchIconButtonStyle,
    searchMainContainerStyle,
    searchIconStyle,
    pageBlurCss,
    displayNone
} from "./search.styles";
export interface SearchProps {
    searchLabel?: string;
    className?: string;
    placeholder?: string;
    searchUrl?: string;
    baseUrl?: string;
    isOpen: boolean;
    openSearch: () => void;
    closeSearch: () => void;
    testId?: string;
}

export const Search = ({
    searchLabel,
    className,
    placeholder,
    searchUrl,
    testId,
    isOpen = false,
    openSearch,
    closeSearch
}: SearchProps) => {
    const [searchText, setSearchText] = useState("");
    const inputRef = useRef<HTMLInputElement>(null);

    const focusOnInput = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    useEffect(() => {
        if (isOpen) {
            focusOnInput();
        }
    }, [isOpen]);

    const intl = useIntl();
    const translated = {
        searchLabel: intl.formatMessage({
            id: "globalNav.search.label",
            defaultMessage: "Search"
        }),
        submitSearch: intl.formatMessage({
            id: "globalNav.search.submit",
            defaultMessage: "Submit"
        }),
        closeSearch: intl.formatMessage({
            id: "globalNav.search.close",
            defaultMessage: "Close"
        })
    };

    return (
        <React.Fragment>
            <button
                css={[
                    searchIconStyle,
                    // hide search icon on mobile when search is open
                    isOpen && displayNone
                ]}
                onClick={(event) => {
                    event.preventDefault();
                    focusOnInput();
                    openSearch();
                }}
                id="global-nav-search-icon"
                aria-label={translated.searchLabel}
                data-testid={testId || "global-nav-search-icon"}
                data-event="clicked"
                data-event-component="linkButton"
                data-event-container="globalNavWac"
                data-product-key="jiraSoftware"
            >
                <SearchIcon label={translated.searchLabel} />
            </button>
            {isOpen && (
                <React.Fragment>
                    <div
                        css={searchMainContainerStyle}
                        className={className}
                        id="global-nav-wac-search"
                        data-testid="search-container"
                    >
                        <form
                            css={searchFormStyle}
                            action={searchUrl || `/search`}
                            method="GET"
                            id="global-nav-wac-search-form"
                            data-testid="search-form"
                        >
                            <div
                                id="global-nav-wac-search-container"
                                css={searchContainerStyle}
                            >
                                <div
                                    css={searchInputContainerStyle}
                                    id="global-nav-wac-search-input-container"
                                >
                                    <TextInput
                                        ref={inputRef}
                                        className="fullWidth"
                                        label={
                                            searchLabel ||
                                            `${translated.searchLabel} atlassian.com`
                                        }
                                        name="q"
                                        id="global-nav-search-input"
                                        value={searchText}
                                        placeholder={
                                            placeholder ||
                                            translated.searchLabel
                                        }
                                        onChangeHandler={setSearchText}
                                        data-testid="search-input"
                                        aria-label="Search Input"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    id="global-nav-search-submit"
                                    css={searchIconButtonStyle}
                                    data-testid="search-submit"
                                    aria-label={translated.submitSearch}
                                    data-event="clicked"
                                    data-event-component="linkButton"
                                    data-event-container="globalNav"
                                >
                                    <SearchIcon
                                        label={translated.submitSearch}
                                    />
                                </button>
                                <button
                                    id="global-nav-search-close"
                                    css={closePanelIconContainerStyle}
                                    onClick={(event) => {
                                        event.preventDefault();
                                        return closeSearch();
                                    }}
                                    data-testid="search-close"
                                    aria-label={translated.closeSearch}
                                    data-event="clicked"
                                    data-event-component="linkButton"
                                    data-event-container="globalNav"
                                >
                                    <Cross size="16" />
                                </button>
                            </div>
                        </form>
                    </div>
                    <button
                        aria-label={translated.closeSearch}
                        css={pageBlurCss}
                        onClick={() => closeSearch()}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-event-container="globalNav"
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    );
};
